import { httpClient } from "./http-client";
import { CompanyDetails } from "./types";

class CompanyService {
    async getCompanyDetails(): Promise<CompanyDetails> {
        return httpClient.get<CompanyDetails>("/api/v1/companies/public");
    }
}

export const companyService = new CompanyService();
